import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20collage%20background%2C%20vibrant%20colorful%20comic%20style%20illustrations%2C%20dramatic%20fantasy%20and%20romance%20art%2C%20dark%20atmospheric%20overlay%2C%20modern%20digital%20illustration%2C%20professional%20comic%20art%2C%20cinematic%20wide%20composition%2C%20warm%20orange%20and%20deep%20red%20tones%2C%20high%20contrast%2C%20no%20text&width=1920&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="韩国漫画网 - 好看的韩国漫画在线免费阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white font-heading leading-tight mb-4">
          好看的韩国漫画<br className="md:hidden" />
          <span className="text-primary-400">在线免费阅读</span>
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          韩国漫画网收录海量好看的韩国漫画，支持韩漫在线免费阅读和无遮韩漫大全。<br className="hidden md:block" />
          涵盖恋爱、奇幻、动作、悬疑、搞笑等全类型，界面友好，为您打造极致舒适的阅读环境。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full transition-all whitespace-nowrap cursor-pointer text-sm"
          >
            立即开始阅读
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/action"
            className="px-8 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-full backdrop-blur-sm transition-all whitespace-nowrap cursor-pointer text-sm"
          >
            热门推荐
            <i className="ri-fire-line ml-2"></i>
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3">
          {categories.filter(c => c.slug !== 'all').slice(0, 8).map(cat => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="px-5 py-2 bg-white/10 hover:bg-white/20 text-white/90 text-xs rounded-full backdrop-blur-sm transition-all whitespace-nowrap cursor-pointer border border-white/10"
            >
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}